module.exports = __webpack_public_path__ + "faf6f5dc44e713178784c1fb053990aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/ui-icons_888888_256x240.png
// module id = 484
// module chunks = 2